import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withEnvironment } from '../extensions/with-environment';
import { withRootStore } from '../extensions/with-root-store';

/**
 * # LoadingStore
 *
 * LoadingStore을 설명하세요.
 */
export const LoadingStore = types
  .model('LoadingStore')
  // --------------------------------------------------------------------------
  .props({
    loading: types.optional(types.boolean, false),
    message: types.optional(types.string, ''),
    tableLoading: types.optional(types.boolean, false),
    tableMessage: types.optional(types.string, ''),
    // 동시에 진행 중인 API 호출 수. boolean 대신 카운터로 관리하여
    // 여러 호출이 겹쳐도 마지막 호출이 끝날 때까지 로딩이 유지되고,
    // 한 호출이 끝났다고 다른 호출 중에 로딩이 꺼지지 않도록 한다.
    pendingCount: types.optional(types.number, 0),
    tablePendingCount: types.optional(types.number, 0),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  .actions((self) => ({
    setLoading: (loading: boolean) => {
      self.loading = loading;
    },
    setMessage: (message: string) => {
      self.message = message;
    },
  }))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    /**
     * API 호출 시작. 진행 카운트를 1 증가시키고 로딩을 켠다.
     */
    allLoading: () => {
      self.pendingCount += 1;
      self.loading = true;
    },
    allLoadingNoMsg: () => {
      self.pendingCount += 1;
      self.message = '';
      self.loading = true;
    },
    /**
     * API 호출 종료. 진행 카운트를 1 감소시키고,
     * 모든 호출이 끝났을 때(0)에만 로딩을 끈다.
     */
    closeLoadingNoMsg: () => {
      self.pendingCount = Math.max(0, self.pendingCount - 1);
      self.message = '';
      if (self.pendingCount === 0) {
        self.loading = false;
      }
    },
    /**
     * 카운터/로딩 상태를 강제로 초기화한다.
     * (화면 전환 등 안전장치가 필요한 경우 사용)
     */
    resetLoading: () => {
      self.pendingCount = 0;
      self.message = '';
      self.loading = false;
    },
    tableLoadingNoMsg: () => {
      self.tablePendingCount += 1;
      self.tableMessage = '';
      self.tableLoading = true;
    },
    tableCloseLoadingNoMsg: () => {
      self.tablePendingCount = Math.max(0, self.tablePendingCount - 1);
      self.tableMessage = '';
      if (self.tablePendingCount === 0) {
        self.tableLoading = false;
      }
    },
  }));
// --------------------------------------------------------------------------

// --------------------------------------------------------------------------
type TLoadingStore = Instance<typeof LoadingStore>;
type TLoadingStoreSnapshot = SnapshotOut<typeof LoadingStore>;

export interface ILoadingStore extends TLoadingStore {}
export type TLoadingStoreKeys = keyof TLoadingStoreSnapshot & string;
export interface ILoadingStoreSnapshot extends TLoadingStoreSnapshot {}
export const createLoadingStore = () => types.optional(LoadingStore, {} as TLoadingStore);
